import axios from "axios";

export async function checkIfCountryHasNoEmissionDateLicenseApi(countryID) {
  return (await (axios.get(`/driver-info/check-non-license-emission-date/${countryID}`))).data;
}